import type from "./types";

const initialState = {
  wizardSelectedStepsIds: []
}


export function saveLoadedWizardStepsId(state = initialState, action = {}) {
  switch (action.type) {
    case type.WIZARD_LOADED_STEPS:
      return {
        ...state,
        wizardSelectedStepsIds: [...state.wizardSelectedStepsIds, action.data]
      }
    case type.DELETE_SELECTED_SEGMENTID:
      return {
        ...state,
        wizardSelectedStepsIds: state.wizardSelectedStepsIds.filter(item => item !== action.data),
      }
    default:
      return state;
  }
}

